import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { getAcademicYears } from "../../redux/actions/academicYearActions";
import AppSelectFilter from "./AppSelectFilter";

interface Props {
  value: string;
  onChange: (yearId: string) => void;
  label?: string;
  allLabel?: string;
  minWidth?: number | string;
}

export const AcademicYearSelectFilter: React.FC<Props> = ({
  value,
  onChange,
  label = "Academic Year",
  allLabel = "All Years",
  minWidth = 140,
}) => {
  const dispatch = useAppDispatch();
  const {
    items: years,
    loadingFetchAll: loading,
    errorFetchAll: error,
  } = useAppSelector((state) => state.academicYear);
  const attempted = useRef(false);

  useEffect(() => {
    if (!years.length && !loading && !error && !attempted.current) {
      attempted.current = true;
      dispatch(getAcademicYears());
    }
  }, [dispatch, years.length, loading, error]);

  return (
    <AppSelectFilter
      label={label}
      value={value}
      onChange={onChange}
      options={years.map((y) => ({ value: y.id, label: y.name }))}
      allLabel={allLabel}
      minWidth={minWidth}
    />
  );
};
export default AcademicYearSelectFilter;
